import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import { Button } from 'antd';

class DownloadAsXLS extends React.Component {
  render() {
    return (<Button
      size="large"
      type="primary"
      icon="cloud-download"
      onClick={() => {
        this.props.dispatch({ type: 'branches/download' });
      }}
    >
      <FormattedMessage id="Component.TargetGroup.New.Form.DownloadBranches" />
    </Button>);
  }
}

export default withRouter(connect(({ branches }) => ({ branches }))(injectIntl(DownloadAsXLS)));




// WEBPACK FOOTER //
// ./src/components/DownloadAsXLS/DownloadAsXLS.js